import script from "./Diseases.vue?vue&type=script&setup=true&lang=js"
export * from "./Diseases.vue?vue&type=script&setup=true&lang=js"

import "./Diseases.vue?vue&type=style&index=0&id=3a85c496&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a85c496"]])

export default __exports__